export default function AnimationDefault({ className }) {
    return (
        <svg id="svg0" width="86" height="85" viewBox="0 0 86 85" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="30" y="30" width="25" height="25" rx="12.5" fill="#262626" />
        </svg>
    )
}